import { GlobalService } from 'src/app/_services/global.service';
import { UserService } from 'src/app/_services/user.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AppBaseDataService } from '../_services/app-base-data.service';
import { SignupService } from '../_services/signup.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { WhiteLabelList } from '../_data/white-label-list';
import { EARLY_WIZARD_FLAG } from '../utils/early-wizard';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    _globals = GlobalService
    private readonly storeSetupV2CompletedPrefix = 'store-setup-v2-completed';
    private readonly forceDashboardAfterStoreSetupV2Key = 'force-dashboard-after-store-setup-v2';

    constructor(private _userService: UserService,
        private _router: Router,
        private _signupService: SignupService,
        public _abd: AppBaseDataService,
        private permissionsService: NgxPermissionsService,
        ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // const x = window.location.host
        let isBusinessSetup = false
        return this._userService.currentUser$.pipe(
        map(user => {
            if (!user) {
                if (window.location.href.includes('/handheld'))
                    this._router.navigate(['handheld/signin2'])
                else
                    this._router.navigate(['pages/signin'])
                return
            }

            // The welcome wizard opened right after signup, while the account is still deploying: the token is enough
            // for its questions, and the checks below would send an account that is deploying to the waiting screen.
            if (state.url.startsWith('/welcome-store') && sessionStorage.getItem(EARLY_WIZARD_FLAG) === '1' && this._globals.userInfo?.isEarly) {
                return true;
            }

            try {

                if (this._globals.userInfo) {
                    // this.loadPermissions()
                    this.redirectToSignup(state.url);
                    // ----
                    this._globals.userInfo.isBusinessSetup = true
                    // --------
                    if (this._globals.userInfo.isBusinessSetup) isBusinessSetup = true
                    else {

                        if (
                            this._globals.userInfo.businessSetup[0].isFreeTrial ||
                            this._globals.userInfo.businessSetup[0].isSubscriptionCompleted)
                        {
                            this._router.navigate(['setup/business-setup'])
                        }

                    }
                }
                else {

                    this._userService.getUserByUserName(this._userService.currentUserObj.userName).subscribe(res => {
                    if (res?.success) {
                        try {
                        const xuser = res.data
                        this._globals.userInfo = xuser
                        // this.loadPermissions()
                        this.redirectToSignup(state.url);

                            xuser.isBusinessSetup = true;
                        if (xuser.isBusinessSetup) isBusinessSetup = true
                        else this._router.navigate(['setup/business-setup'])
                        } catch { }
                    }
                    })
                }

                if (user && isBusinessSetup) return true;
            } catch { }
            this._abd.initMenuList(false)
        })

        )
    }

    loadPermissions(){
            // console.lo g('Load Permissions', this._globals.userInfo.userRights)
            return this.permissionsService?.loadPermissions(this._globals.userInfo.userRights);
      }

    redirectToSignup(returnUrl?: string){
        sessionStorage.setItem('un-verified-account', "0")
        if (sessionStorage.getItem(this.forceDashboardAfterStoreSetupV2Key) === '1') {
            sessionStorage.removeItem(this.forceDashboardAfterStoreSetupV2Key);
            return;
        }

        const setup = this._globals.userInfo?.businessSetup?.[0];
        const isFreeTrial = this.toBooleanFlag(setup?.isFreeTrial ?? setup?.IsFreeTrial);
        const isSubscriptionCompleted = this.toBooleanFlag(
            setup?.isSubscriptionCompleted ?? setup?.IsSubscriptionCompleted
        );
        // A completed signup that landed on the Free plan is neither "on a free trial" nor has a
        // "completed subscription" — isFreeTrial/isSubscriptionCompleted are both false for it,
        // same as a genuinely abandoned mid-signup account. Without this, every dashboard-route
        // activation for a finished Free-plan account gets bounced back into /signup forever — same
        // bug as user.service.ts's autologin(), fixed there with the same accountStatusString
        // check (the authoritative "is this account done" signal subscription-payment-success's own
        // deployment poll already trusts: anything other than 'DeploymentInProgress' means ready).
        const accountStatusString = setup?.accountStatusString ?? setup?.AccountStatusString ?? '';
        const isDeploymentDone = !!accountStatusString && accountStatusString !== 'DeploymentInProgress';

        // Users who completed store setup v2 should always be allowed to land on dashboard routes.
        if (this.isStoreSetupV2CompletedForCurrentUser()) {
            return;
        }

        // Genuinely still deploying (the backend's own "you'll get an email, login again later"
        // state) — show a waiting screen that polls and continues automatically once ready, instead
        // of silently dumping the user back into signup step 1 with no explanation, discarding
        // whatever route they were actually trying to reach.
        if (accountStatusString === 'DeploymentInProgress') {
            sessionStorage.setItem('deployment-pending-return-url', returnUrl || this._abd.getDashboardRoute());
            this._router.navigate(['deployment-pending']);
            return false;
        }

         // //// Signup-Redirect
        if (!isDeploymentDone &&
            !isFreeTrial &&
            !isSubscriptionCompleted
            ) {
                // let wll = WhiteLabelList[0]
                // if(wll.wlName === 'LincSell'){
                //     sessionStorage.setItem('un-verified-account',"1")
                //     // this._signupService.setInitialSubscriptionDetail(this._globals.userInfo);
                //     // this._router.navigate([""])
                //     return false
                // }else{
                sessionStorage.setItem('un-verified-account',"1")
                this._signupService.setInitialSubscriptionDetail(this._globals.userInfo);
                //this._router.navigate(["signup/personal-info"])
                this._router.navigate(["signup"])
                // this._router.navigate(['setup/subscription-plans'])
                return false
                // }

            }

        // //// Signup-Redirect
        if (
            isSubscriptionCompleted
            && window.location.href.includes('subscription-plan-selection')
            // && window.location.href.includes('/setup/subscription-plans')
        ) {


            this._router.navigate(['/'])
            return false
        }
        // //// Signup-Redirect
    }

    private isStoreSetupV2CompletedForCurrentUser(): boolean {
        try {
            return localStorage.getItem(this.getStoreSetupV2CompletedKey()) === '1';
        } catch {
            return false;
        }
    }

    private getStoreSetupV2CompletedKey(): string {
        const setup = this._globals.userInfo?.businessSetup?.[0] || {};
        const businessId = String(setup?.businessId ?? setup?.id ?? 'default-business');
        const userId = String(this._globals.userInfo?.userID ?? this._globals.userInfo?.userId ?? 'default-user');
        return `${this.storeSetupV2CompletedPrefix}-${userId}-${businessId}`;
    }

    private toBooleanFlag(value: any): boolean {
        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            return normalized === 'true' || normalized === '1';
        }
        return value === true || value === 1;
    }

}
